import useTypedContext from "hooks/useTypedContext";
import Stepper from "ds/components/Stepper";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import StepperHeader from "ds/components/Stepper/Header";

import { ModuleFormContext } from "../context";
import { isStepRequired } from "../utils";
import { useNewModuleAnalyticsSegmentEvent } from "../useNewModuleAnalyticsSegmentEvent";
import { ModuleCreationWizardStep } from "../types";

const NewModuleStepper = () => {
  const trackSegmentEvent = useNewModuleAnalyticsSegmentEvent();

  const {
    availableSteps,
    currentStep,
    currentStepIndex,
    setCurrentStep,
    stepperNavDisabled,
    isIntermediateStepActive,
    setIsIntermediateStepActive,
  } = useTypedContext(ModuleFormContext);

  const setStep = (step: ModuleCreationWizardStep) => {
    if (isIntermediateStepActive) {
      setIsIntermediateStepActive(false);
    }

    setCurrentStep(step);

    trackSegmentEvent("Step click", {
      currentStep,
      newStep: step,
    });
  };

  return (
    <Stepper>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {[...availableSteps].map((item, index) => (
          <StepperStep
            disabled={stepperNavDisabled || index > currentStepIndex}
            key={item.step}
            active={item.step === currentStep}
            onClick={index < currentStepIndex ? () => setStep(item.step) : undefined}
          >
            {item.name}
            {item.isOptional && !isStepRequired(item.step) && " (optional)"}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default NewModuleStepper;
